import React from "react";
import { Card, Col, Row, Button } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";

const COLORS = ["#506fd9", "#6b8de6", "#85b6ff", "#41505f", "#c1d4f6"];

const SkeletonDonut = () => (
   <Card className="card-one" style={{ minHeight: "380px" }}>
      <Card.Header>
         <div className="placeholder-glow" style={{ width: "60%" }}>
            <span className="placeholder col-8 d-block" style={{ height: "16px" }}></span>
         </div>
      </Card.Header>
      <Card.Body className="d-flex align-items-center justify-content-center">
         <div className="placeholder-glow d-flex flex-column align-items-center">
            <span className="placeholder rounded-circle" style={{ width: "160px", height: "160px" }}></span>
         </div>
      </Card.Body>
      <Card.Footer className="p-3">
         <Row className="g-3">
            {Array.from({ length: 5 }).map((_, i) => (
               <Col key={i} className="text-center placeholder-glow">
                  <span className="placeholder rounded-circle d-block mx-auto" style={{ width: 8, height: 8 }}></span>
                  <span className="placeholder col-6 d-block mx-auto mt-1" style={{ height: "12px" }}></span>
                  <span className="placeholder col-8 d-block mx-auto mt-1" style={{ height: "10px" }}></span>
               </Col>
            ))}
         </Row>
      </Card.Footer>
   </Card>
);

const ErrorDonut = ({ onRetry }) => (
   <Card className="card-one" style={{ minHeight: "380px" }}>
      <Card.Header>
         <Card.Title as="h6">Reconciliation Breakdown</Card.Title>
      </Card.Header>
      <Card.Body className="d-flex flex-column align-items-center justify-content-center">
         <p className="text-muted mb-3">Failed to load breakdown data</p>
         {onRetry && (
            <Button variant="primary" size="sm" onClick={onRetry}>
               Retry
            </Button>
         )}
      </Card.Body>
   </Card>
);

const ReconBreakdownDonut = ({ data, isLoading, isError, onRetry }) => {
   if (isLoading) return <SkeletonDonut />;
   if (isError) return <ErrorDonut onRetry={onRetry} />;

   const { series, labels, legendItems, centerValue, centerLabel } = data;

   return (
      <Card className="card-one">
         <Card.Header>
            <Card.Title as="h6">Current Month Reconciliation Breakdown</Card.Title>
         </Card.Header>
         <Card.Body className="position-relative d-flex justify-content-center">
            <ReactApexChart
               series={series}
               options={{
                  chart: { parentHeightOffset: 0 },
                  colors: COLORS,
                  labels: labels,
                  dataLabels: { enabled: false },
                  legend: { show: false },
                  grid: { padding: { top: 0, bottom: 0 } },
               }}
               height="auto"
               type="donut"
               className="apex-donut-two"
            />
            <div style={{
               position: "absolute", top: 0, right: 0, bottom: 0, left: 0,
               display: "flex", flexDirection: "column", alignItems: "center",
               justifyContent: "center", pointerEvents: "none",
            }}>
               <h1 className="fw-semibold mb-0" style={{ letterSpacing: "-1px" }}>{centerValue}</h1>
               <p className="text-secondary mb-0 fs-sm">{centerLabel}</p>
            </div>
         </Card.Body>
         <Card.Footer className="p-3">
            <Row className="g-3">
               {legendItems.map((item, i) => (
                  <Col key={i} className="text-center">
                     <span className="d-block" style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: item.color, margin: "0 auto 4px" }}></span>
                     <small className="fw-medium d-block">{item.value}</small>
                     <small className="text-secondary">{item.label}</small>
                  </Col>
               ))}
            </Row>
         </Card.Footer>
      </Card>
   );
};

export default ReconBreakdownDonut;
